// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"2975194f","920":"5f38314f","942":"ef3d2445","978":"288c659d"}[chunkId] + ".chunk.js";
};